<div class="container-fluid">
    <div class="header-container">
        <div class="page-header">
            {{ "bikeshop.shop_setup.card_headers.rental_checklist_configuration" | translate }}
        </div>
    </div>
    <div>

        <app-beta-message></app-beta-message>
    </div>
</div>
